export enum VideoType {
  Animation = 'Animation',
  // Youtube = 'Youtube', // Disabled for initial launch
  // Wistia = 'Wistia', // Disabled for initial launch
}

export enum ControlsLocation {
  OutsideBottomLeft = 'Outside, Bottom Left',
  InsideBottomLeft = 'Inside, Bottom Left',
  InsideBottomRight = 'Inside, Bottom Right',
  InsideTopRight = 'Inside, Top Right',
}
